import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { InfinityList } from '@widgets/shared/InfinityList/index.tsx';
import { Blank } from '@src/library/components/common';
import { useLoadAcquiredEvets } from '../../model';
import { EventAcquiredCard } from '../event-acquired-card';

interface Props {
  id: number;
  code: string;
}

export const AcquiredEventsList: FC<Props> = ({ id, code }) => {
  const { loading, events, hasNextPage, loadMore } = useLoadAcquiredEvets(id, code);

  return (
    <InfinityList hasMore={hasNextPage} loadMore={loadMore} loading={loading}>
      {!loading && !events.length && <Blank text="Здесь пока нет мероприятий" />}
      {events.map((event, idCard) => (
        <Link to={event.id ? `/events/${code}/${event.id}` : ''} key={idCard}>
          <EventAcquiredCard event={event} />
        </Link>
      ))}
    </InfinityList>
  );
};
